// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';
import weeklyTimetableWidgetConsts from './weeklyTimetableWidgetConsts';
import editorActionsService from '../../common/editorActionsService';
import experiments from 'experiment';

export default function ({ editorAPI }: AnyFixMe) {
  const isWixStudio = experiments.isOpen(
    'specs.responsive-editor.BookingsChangeImagesOnAddPanel',
  );
  const actionsService = editorActionsService({ editorAPI });
  const addPanelConsts = addPanelDataConsts;

  const weeklyTimetableWidget = {
    id: weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_PRESET_KEY,
    structure: {
      layout: {
        width: 980,
        height: 558,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
      data: {
        type: 'TPAWidget',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
        applicationId: '2269',
        tpaData: {
          type: 'TPAData',
          metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
          content: `{"presetId":"${weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_PRESET_KEY}"}`,
        },
        widgetId: weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_WIDGET_ID,
      },
      style: {
        type: 'TopLevelStyle',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.tpapps.TPAWidget',
        pageId: '',
        compId: '',
        styleType: 'custom',
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
      },
    },
    preset: {
      rect: isWixStudio
        ? { width: 324, height: 203, x: 0, y: 0 }
        : { width: 304, height: 171, x: 10, y: 10 },
      label: '',
      tags: null,
    },
  };

  const weeklyTimetableWidgetItems = [weeklyTimetableWidget];

  return {
    id: 'wixBookingsWeeklyTimetableWidget',
    type: addPanelConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title: weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_TITLE_KEY,
    subNavigationTitle: weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_TITLE_KEY,
    presetTitle: weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_TITLE_KEY,
    tooltipTitle:
      weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_TOOLTIP_TITLE_KEY,
    tooltipDescription:
      weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_TOOLTIP_DESCRIPTION_KEY,
    showSectionHeader: true,
    additionalBehaviours: {
      labelMode: addPanelConsts.LABEL_BEHAVIOUR.ALWAYS,
      infoIcon: addPanelConsts.INFO_ICON_BEHAVIOUR.NONE,
      hoverImageAction: addPanelConsts.HOVER_IMAGE_ACTIONS.NONE,
      scaleProportion: addPanelConsts.DEFAULT_SCALE_FOR_PRESET,
      iconEnabledForComps: [] as AnyFixMe,
    },
    props: {
      image: isWixStudio
        ? weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_WIDGET_WIX_STUDIO_IMAGE
        : weeklyTimetableWidgetConsts.WEEKLY_TIMETABLE_WIDGET_IMAGE,
      imageHover: null as AnyFixMe,
      onDrop: actionsService.onRefWidgetDrop,
      items: weeklyTimetableWidgetItems,
      compTypes: ['wysiwyg.viewer.components.tpapps.TPAWidget'],
    },
    onClick: actionsService.onRefWidgetClick,
  };
}
